import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components/Text/Text';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const GroupLabel = styled(Text)`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${COLORS.textFaint};
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ToggleCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ToggleTitle = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const ToggleHint = styled(Text)`
  font-size: 12px;
  line-height: 1.5;
  color: ${COLORS.textFaint};
`;
